const generateUniqueId = (prefix, suffix) => {
    // Due to nature of random numbers, it is best to provide both prefix and suffix with some sort of unique number,  
    // such as index position if being used by an item in an array.
    const randomNumber = Math.floor(Math.random() * 100)
    const timestamp = Date.now()

    return `${prefix}-${randomNumber}-${timestamp}-${suffix}`
}

export {
    generateUniqueId
}